// @generated by protoc-gen-es v1.2.0 with parameter "target=ts,import_extension=.ts"
// @generated from file protogen/billing.proto (package protogen, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum protogen.PlatformFeeSchedule
 */
export enum PlatformFeeSchedule {
  /**
   * @generated from enum value: SCHEDULE_NOT_SET = 0;
   */
  SCHEDULE_NOT_SET = 0,

  /**
   * @generated from enum value: SCHEDULE_NO_FEE = 1;
   */
  SCHEDULE_NO_FEE = 1,

  /**
   * @generated from enum value: SCHEDULE_FLAT_10 = 2;
   */
  SCHEDULE_FLAT_10 = 2,

  /**
   * @generated from enum value: SCHEDULE_LEAD_GEN_30_30_30_10 = 3;
   */
  SCHEDULE_LEAD_GEN_30_30_30_10 = 3,

  /**
   * @generated from enum value: SCHEDULE_FLAT_15 = 4;
   */
  SCHEDULE_FLAT_15 = 4,

  /**
   * @generated from enum value: SCHEDULE_LEAD_GEN_30_30_30_15 = 5;
   */
  SCHEDULE_LEAD_GEN_30_30_30_15 = 5,

  /**
   * @generated from enum value: SCHEDULE_LEAD_GEN_35_35_35_20 = 6;
   */
  SCHEDULE_LEAD_GEN_35_35_35_20 = 6,

  /**
   * @generated from enum value: SCHEDULE_LEAD_GEN_43_43_43_30 = 8;
   */
  SCHEDULE_LEAD_GEN_43_43_43_30 = 8,

  /**
   * @generated from enum value: SCHEDULE_FLAT_20 = 7;
   */
  SCHEDULE_FLAT_20 = 7,

  /**
   * @generated from enum value: SCHEDULE_LEAD_GEN_45_45_45_25 = 9;
   */
  SCHEDULE_LEAD_GEN_45_45_45_25 = 9,

  /**
   * @generated from enum value: SCHEDULE_FLAT_25 = 10;
   */
  SCHEDULE_FLAT_25 = 10,

  /**
   * @generated from enum value: SCHEDULE_ADVISOR_DISCOUNT_35_15 = 11;
   */
  SCHEDULE_ADVISOR_DISCOUNT_35_15 = 11,
}
// Retrieve enum metadata with: proto3.getEnumType(PlatformFeeSchedule)
proto3.util.setEnumType(PlatformFeeSchedule, "protogen.PlatformFeeSchedule", [
  { no: 0, name: "SCHEDULE_NOT_SET" },
  { no: 1, name: "SCHEDULE_NO_FEE" },
  { no: 2, name: "SCHEDULE_FLAT_10" },
  { no: 3, name: "SCHEDULE_LEAD_GEN_30_30_30_10" },
  { no: 4, name: "SCHEDULE_FLAT_15" },
  { no: 5, name: "SCHEDULE_LEAD_GEN_30_30_30_15" },
  { no: 6, name: "SCHEDULE_LEAD_GEN_35_35_35_20" },
  { no: 8, name: "SCHEDULE_LEAD_GEN_43_43_43_30" },
  { no: 7, name: "SCHEDULE_FLAT_20" },
  { no: 9, name: "SCHEDULE_LEAD_GEN_45_45_45_25" },
  { no: 10, name: "SCHEDULE_FLAT_25" },
  { no: 11, name: "SCHEDULE_ADVISOR_DISCOUNT_35_15" },
]);

/**
 * @generated from message protogen.BillingProduct
 */
export class BillingProduct extends Message<BillingProduct> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: string description = 3;
   */
  description = "";

  /**
   * @generated from field: int32 amountCents = 4;
   */
  amountCents = 0;

  /**
   * @generated from field: int32 serviceHours = 5;
   */
  serviceHours = 0;

  constructor(data?: PartialMessage<BillingProduct>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.BillingProduct";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "amountCents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "serviceHours", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingProduct {
    return new BillingProduct().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingProduct {
    return new BillingProduct().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingProduct {
    return new BillingProduct().fromJsonString(jsonString, options);
  }

  static equals(a: BillingProduct | PlainMessage<BillingProduct> | undefined, b: BillingProduct | PlainMessage<BillingProduct> | undefined): boolean {
    return proto3.util.equals(BillingProduct, a, b);
  }
}

/**
 * @generated from message protogen.BillingCoupon
 */
export class BillingCoupon extends Message<BillingCoupon> {
  /**
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * @generated from field: string name = 2;
   */
  name = "";

  /**
   * @generated from field: int32 amountOffCents = 3;
   */
  amountOffCents = 0;

  /**
   * @generated from field: float percentOff = 4;
   */
  percentOff = 0;

  /**
   * @generated from field: string duration = 5;
   */
  duration = "";

  /**
   * @generated from field: int32 durationInMonths = 6;
   */
  durationInMonths = 0;

  constructor(data?: PartialMessage<BillingCoupon>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "protogen.BillingCoupon";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "amountOffCents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "percentOff", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "duration", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "durationInMonths", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): BillingCoupon {
    return new BillingCoupon().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): BillingCoupon {
    return new BillingCoupon().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): BillingCoupon {
    return new BillingCoupon().fromJsonString(jsonString, options);
  }

  static equals(a: BillingCoupon | PlainMessage<BillingCoupon> | undefined, b: BillingCoupon | PlainMessage<BillingCoupon> | undefined): boolean {
    return proto3.util.equals(BillingCoupon, a, b);
  }
}

